/*
*
* File JS componente Block Service
*
*/

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './block-tab-service.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const blockTabService = () => {
    const context = document.querySelector('.block-tab-service');
    if(!context) return;

    const headerTabs = context.querySelectorAll('.block-tab-service__head > a');
    const contentTabs = context.querySelectorAll('.block-tab-service__body > div');
    if(!headerTabs || !contentTabs) return;

    headerTabs.forEach(item => {

        item.addEventListener('click' , (e) => {
            e.preventDefault();
            const currentDatTab = item.getAttribute('data-tab');

            if(currentDatTab)  {
                const contentToShow = context.querySelector(`.block-tab-service__content[data-tab='${currentDatTab}']`);
                toggleContentTabs(contentToShow);
                toggleHeader(item);
            }

        })

    });

    function toggleContentTabs(showTab) {
        contentTabs.forEach(item => {
          item.classList.remove('active');
          item.classList.remove('fade-in');
        });
        showTab.classList.add('active');

        setTimeout(() => {
          showTab.classList.add('fade-in');
        }, 50); 
      }

      function toggleHeader(showHeader)
      {
          headerTabs.forEach(item => {
              item.setAttribute('aria-selected', 'false');
              item.classList.remove('active');
          });
  
          showHeader.classList.add('active');
          showHeader.setAttribute('aria-selected', 'true');
      }

}



export default blockTabService;

//--------------------------------------------------------------------//